import React from 'react';
import Colors from "../../constants/colors"
import { view_styles } from "../../constants/styles"
import { Button, Text, View } from '../../Components/Themed';

type BidToggleProps = { 
    cl: string,
    sq_square_id:string,
    amount:number,
    onAmountChange:(dir:'increase'|'decrease') => void
}

const BidToggle = ({ cl, amount, onAmountChange }:BidToggleProps) => {
    return (
        <View style={{ ...view_styles.body_row, borderWidth:1, borderColor:Colors.accents.accent200, borderRadius:4, padding:0 }}>
            <Button style={{ justifyContent:'center', alignItems:'center', padding:12, borderRightWidth:1, borderRightColor:Colors.accents.accent200}} onPress={() => onAmountChange('decrease')}>
                <Text size={16} weight='semibold' theme='action' textAlign='center'>-</Text>
            </Button>
            <Text style={{ marginLeft:4, marginRight:4 }} theme="h2">{cl}{amount.toFixed(2)}</Text>
            <Button style={{ justifyContent:'center', alignItems:'center', padding:12,  borderLeftWidth:1, borderLeftColor:Colors.accents.accent200}} onPress={() => onAmountChange('increase')}>
                <Text size={16} weight='semibold' theme='action' textAlign='center'>+</Text>
            </Button>
        </View>
    )
}

export default BidToggle